import React from "react";
import styles from "../assets/css/modules/myprofile/contact-us-for-payment.css";
import { getPhone } from "../helpers/ContentStateHelper";


const mail = "icon-phone";
const ContactusForPayment =

{
  title: (<React.Fragment><span className={styles.downTimeTitle}>Need to change bank details for payments we collect from you?</span></React.Fragment>),
  body: {
    Any: (props) => 

    (<>
    
    <p>Changing these details won't change the account we collect payments from - only the account we pay money to. To change the account we collect payments from, please contact us.</p>
    <span className={styles.secondaryBlueButton}>
      <button
        id={"edit_bank"}
        buttonType="secondaryBlueButton">
        <a href={`tel:${(getPhone(props))}`}>{`Call us ${(getPhone(props))}`}<i className={mail + " " + styles.phoneIcon} /> </a>
        {" "}
      </button>
    </span>

    </>)},


  mail: "Send a message",

};
export default ContactusForPayment;